export default __webpack_public_path__ + "static/media/forgot-password-v2.490e62f0.svg";